module.exports = __webpack_public_path__ + "img/oaks-nest-nook-2.4a7de792.jpeg";